import React, { Component, useRef } from 'react';
import { createRoot } from 'react-dom/client';

import { useTranslation } from "react-i18next";
import * as commonFunc from 'scripts/common';
import CDataTable, { setDtNoSelect } from "components/CDataTable";
//import AGenerateModel from './generic/AGenerateModel';
import Swal from "sweetalert2";
import { GridStack } from 'gridstack';
import AConfigureModel, { SubGenModal } from 'components/generic/AConfigureModel';

import { withRouter } from 'components/withRouter';

import {
    Button,
} from "reactstrap";

class ModelEditor extends Component {
    static displayName = ModelEditor.name;

    static siteModels;

    static modalRoot;
    static user;

    constructor(props) {
        super(props);

        //var defaultGridStackData = [];

        var entity = props.searchParams.get("entity") || "SITE";
        var extID = props.searchParams.get("extID") || "";//HOME
        var categ = props.searchParams.get("categ") || "MOBILE";

        var defaultGridStackData = [
            { id: "gs-storage", hidden: false, type: extID, title: "Fichiers Stockés", x: 0, y: 0, w: 12, h: 40 },

        ];
        this.state = { entity: entity, categ: categ, extID: extID, gridData: JSON.stringify(defaultGridStackData), render: false, dataStamp: 0, showEditor: !commonFunc.isBlank(extID) };
    }

    componentDidMount() {
        var context = this;
        if (this.props.updateUser) this.props.updateUser(function (curUser) {

            context.user = curUser;
            context.updateModels();
        });
    }

    componentWillUnmount() {
        //console.debug("unmount");
        if (this.modalRoot) {
            this.modalRoot.unmount();
            this.modalRoot = null;
        }
    }

    updateModels() {
        var context = this;
        //"../api/report/GetReportModels", { id: -1, categ: "MOBILE", extId:"DTL_REPORT_NEW" }
        //commonFunc.getMethod("../api/site/GetSiteModels", { id: -1 }).then((responseModels) => {
        commonFunc.getMethod("../api/data/GetAllModels", { categ: context.state.categ }).then((responseModels) => {
            var dataModels = responseModels.data;
            if (dataModels.isSuccess) {

                context.siteModels = {};
                /*dataModels.result.models.forEach((model) => {
                    context.siteModels[model.extID] = JSON.parse(model.value);
                });*/
                dataModels.result.forEach((model) => {
                    if (model.tag) {
                        var jsonModel = JSON.parse(model.tag.value);
                        jsonModel.idModel = model.tag.idModel;
                        jsonModel.modelTitle = model.tag.title;
                        context.siteModels[model.tag.extID] = jsonModel;
                    }
                });
                context.setState({ render: !context.state.render, models: dataModels.result.filter(model => !model.tag || !model.tag.extID.endsWith("_BROUILLON")), dataStamp: new Date().getTime() });

            } else {
                Swal.fire({
                    icon: "error",
                    title: context.props.i18nManager.t("gal_fail"),
                    html: context.props.i18nManager.t("gal_failLoadModels") + " :<br>" + dataModels.errorMessage
                });
            }
        });
    }

    render() {
        var context = this;

        var listCb = function () {
            /*if (context.refreshCb) {
                if (context.refreshCb && typeof (context.refreshCb) === "function") { context.refreshCb(); }
                context.refreshCb = null;
            }*/
        };
        var dtConfig = {
            columns: [{ data: "tag.idModel", customTitle: "#" }, { data: "tag.title", customTitle: "Titre" }, { data: "tag.extID", customTitle: "Tag" }, { data: "tag.idModel", customTitle: "Actions", "customClass": "renderingActions" }],
            "rowId": "tag.idModel",// /!\ ID NON UNIQUE
            "generateColumns": true,
            "select": {
                "style": "single",
                "selector": "td:not(:last-child)"
            },
            columnDefs: [
                {
                    createdCell: (td, cellData, rowData, row, col) => {
                        var currRoot = createRoot(td);
                        currRoot.render(<>
                            {context.props.checkRights(rowData.value + "_MODELS", "U") ? <Button className='btn-icon m-0 ms-1' color="primary" size="sm"
                                onClick={() => {
                                    var id = rowData.tag?.idModel;
                                    if (parseInt(id) > 0) {
                                        context.displayEditor(id, rowData);
                                    }
                                }} title={context.props.i18nManager.t("gal_edit")}><i className='fa fa-edit'></i></Button> : ""}
                            {context.props.checkRights(rowData.value + "_MODELS", "R") ? <Button className='btn-icon btn-simple m-0 ms-1' color="dark" size="sm"
                                onClick={() => {
                                    var id = rowData.tag?.idModel;
                                    if (parseInt(id) > 0) {
                                        context.showPreview(id, rowData);
                                    }
                                }} title={context.props.i18nManager.t("gal_show")}><i className='fa fa-eye'></i></Button> : ""}
                            {context.props.checkRights(rowData.value + "_MODELS", "D") ? <Button className='btn-icon m-0 ms-1' color="danger" size="sm"
                                onClick={() => {
                                    var id = rowData.tag?.idModel;
                                    if (parseInt(id) > 0) {
                                        context.removeModel(id, rowData);
                                    }
                                }} title={context.props.i18nManager.t("gal_remove")}><i className='fa fa-trash'></i></Button> : ""}
                            {context.props.checkRights(rowData.value + "_MODELS", "R") ? <Button className='btn-icon btn-simple m-0 ms-1' color="dark" size="sm"
                                onClick={() => {
                                    var id = rowData.tag?.idModel;
                                    if (parseInt(id) > 0) {
                                        context.showHistorical(id, rowData);
                                    }
                                }} title={context.props.i18nManager.t("gal_flows")}><i className='fa fa-clock-rotate-left'></i></Button> : ""}
                        </>);
                    }, "targets": "renderingActions"
                },
            ],
            dtOnSelect: function (dataSel) {
                var id = dataSel.tag?.idModel;
                if (parseInt(id) > 0 && context.props.checkRights(dataSel.value + "_MODELS", "U")) {
                    context.displayEditor(id, dataSel);
                }
                else {
                    setDtNoSelect("tableModels");
                }
            },
            dtOnUnselect: function (dataSel) {
                context.displayEditor();
            },
            dtOnDblClick: function (event) {
                /*var id = parseInt(getDtSelID("lstActs"));
                var currId = parseInt($(this).closest("tr").prop("id"));
                if (currId != id) {
                    scrollToId("detailAct");
                    showDtSelID("lstActs", currId);
                }
                else {
                    if (currId > 0) {
                        scrollToId("detailAct");
                    }
                }*/
            },
            cbInitComplete: function (cRootList) {
                //Swal.close();

                /*cRootList.map((prop, elem) => {
                    console.debug(elem);
                    if (elem.classList.contains("cneedroot")) {
                        var rootElem = createRoot(elem);
                        switch (elem.getAttribute("cneedroot")) {
                            case "forceLogout":
                                rootElem.render(<button className="btn btn-primary btn-icon" onClick={() => context.forceLogout('hey!')}><i className='fa fa-edit'></i></button>);
                                break;
                            default:
                                break;
                        }
                    }
                    return null;
                });*/

                //$("#report_select_filters").appendTo($(".dt-buttons").parent().parent());
                //$("#report_select_filters").removeClass("d-none").addClass("d-inline-block");

                //updateSidebar();

                listCb();
            },
            cbCustom: function () {
                listCb();
            }
        };


        document.body.classList.add("sidebar-mini");
        // <ModelEditorComponent {...this.props} type={"optionsEdit" + (this.user.groupSId || "")} data={this.state.gridData} extID={this.state.extID} configModel={this.siteModels} />

        console.debug(context.siteModels);

        return this.user && this.siteModels ? (<>
            <h5 className="d-none">Editor Page</h5>
            {this.state.showEditor ? <ModelEditorComponent {...this.props} type={"optionsEdit" + (this.user.groupSId || "")} data={this.state.gridData} modelSrc={{ saveCb: this.updateModels.bind(this), entity: this.state.entity, categ: this.state.categ, extID: this.state.extID }} configModel={this.siteModels} reset={() => { this.setState({ showEditor: false, extID: "" }) }} />
                : <CDataTable key="models" dtId={"tableModels"} data={this.state.models} localConfig={dtConfig} /*tag={"DT_RPTS"} config={this.siteModels["DT_RPTS"]}*/ stamp={this.state.dataStamp} /*functionPanel={this.dtFunctionPanel.bind(this)}*/
                    className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} />}
        </>
        ) : "";
    }

    displayEditor(id, dataSel) {
        console.debug(dataSel);
        if (dataSel) this.setState({ showEditor: (dataSel.tag?.extID ? true : false), extID: dataSel.tag?.extID, categ: dataSel.tag?.categ, entity: dataSel.value });
        else this.setState({ showEditor: false, extID: "" });
    }

    
    showPreview(id, dataSel) {
        var context = this;
        var callbackModal = function (dataElem, valueProc) {
            return new Promise((resolve, reject) => {
                if (context.modalRoot) {
                    context.modalRoot.unmount();
                    context.modalRoot = null;
                }
            });
        };

        var modelPrepared = JSON.parse(dataSel.tag?.value);

        context.modalRoot = createRoot(document.createElement('div'));
        context.modalRoot.render(<SubGenModal t={context.props.i18nManager.t} configModel={modelPrepared} appProps={context.props} checkRights={context.props.checkRights} dataCfg={context.props.dataCfg} getRoutes={context.props.getRoutes}
            genId={0} genType={"REPORT"} subType={"REPORT"} itemData={{ subType: "REPORT", argumentsObj: {} }} size={null} title={"Aperçu"} callback={callbackModal} />);
    }

    removeModel(id, dataSel) {
        //TODO : removeModel
    }

    showHistorical(id, dataSel) {
        var context = this;


        var categ = dataSel.tag.categ + "_DRAFT";

        var args = { categ: categ };
        var url = "../api/" + dataSel.value + "/Get" + dataSel.value + "Models";
        if (dataSel.value === "SITE") {
            args.id = -1;
            url = "../api/site/GetSiteModelsList";
        }

        commonFunc.getMethod(url, args).then((responseModels) => {
            var dataModels = responseModels.data;
            if (dataModels.isSuccess && dataModels.result?.length) {
                /*var callbackModal = function (dataElem, valueProc) {
                    return new Promise((resolve, reject) => {
                        if (context.modalRoot) {
                            context.modalRoot.unmount();
                            context.modalRoot = null;
                        }
                    });
                };*/

                var dtFlowsConfig = null;
                var filteredDraft = dataModels.result.filter(model => model.tag.extID === dataSel.tag.extID);
                if (filteredDraft?.length) {
                    context.modalRoot = createRoot(document.createElement('div'));
                    context.modalRoot.render(<CDataTable key="flows" dtId={"tableFlows"} data={filteredDraft} localConfig={dtFlowsConfig} /*tag={"DT_SALS"} config={this.employeeModels["DT_SALS"]} stamp={null} functionPanel={this.dtFunctionPanel.bind(this)}*/
                        className="table-striped table-hover nowrap" style={{ fontSize: "90%" }} />);
                }
                else {
                    Swal.fire({
                        icon: "error",
                        title: "Historique",
                        html: "Aucun historique de modèle"
                    });
                }
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Historique",
                    html: "Aucun historique de modèle"
                });
            }
        });
    }

}

const withI18n = (Component) => {
    return props => {
        const i18n = useTranslation();
        return <Component {...props} i18nManager={{ ...i18n }} />
    }
}


export default withRouter(withI18n(ModelEditor));




const ModelEditorComponent = React.forwardRef((props, ref) => {

    const modalGenManager = useRef(null);
    const gridRef = useRef(null);
    //const [grid, setGrid] = useState(null);
    //const [widgets, setWidgets] = useState([]);

    const widgetsData = [
        {
            id: "widget1",
            content: "<h3>Widget 1</h3><p>Contenu du widget 1</p>",
            x: 0,
            y: 0,
            width: 2,
            height: 2
        },
        {
            id: "widget2",
            content: "<h3>Widget 2</h3><p>Contenu du widget 2</p>",
            x: 2,
            y: 0,
            width: 2,
            height: 2
        }
    ];

    React.useEffect(() => {
        const gridInstance = GridStack.init({
            cellHeight: 80,
            float: true,
            resizable: { handles: 'e, se, s, sw, w' }
        }, gridRef.current);
        // setGrid(gridInstance);


        widgetsData.forEach(widget => {
            /*gridInstance.addWidget(`
        <div>
          <div class="grid-stack-item-content bg-primary">
            <Editor
              apiKey="YOUR_TINYMCE_API_KEY"
              initialValue="${widget.content}"
              init={{
                height: 300,
                menubar: false,
                plugins: [
                  'advlist autolink lists link image charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount'
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
                  alignleft aligncenter alignright alignjustify | \
                  bullist numlist outdent indent | removeformat | help'
              }}
            />
          </div>
        </div>`,
                { x: widget.x, y: widget.y, width: widget.width, height: widget.height }
            );*/

            //gridInstance.addWidget(<CGridStack />);

        });

        return () => {
            gridInstance.destroy();
        };


    }, []);

    console.debug(props.data);
    console.debug(props.configModel);
    var gendata = null;
    var loadExtID = props.modelSrc?.extID;
    if (props.configModel) {
        if (props.configModel && props.configModel[loadExtID + "_BROUILLON"]) loadExtID = loadExtID + "_BROUILLON";

        gendata = JSON.parse(JSON.stringify(props.configModel[loadExtID]));
        if (gendata.templates) {
            gendata.templates.forEach((template) => {
                console.debug("**Template ");
                template.categories.forEach((category) => {
                    console.debug("****Category ");
                    category.headers.forEach((header) => {
                        console.debug("******Header ");
                        header.groups.forEach((group, index) => {
                            //Gestion des clé primaires/secondaires
                            //if (parentProps && parentProps.type && keyMode > 0 && index === 0) {
                            //}
                            console.debug("********Group ");
                            group.items.forEach((item) => {//children
                                console.debug("********@@Item ");
                            });
                        });
                    });
                });
            });
        }
    }

    return (
        <div>
            <AConfigureModel key={gendata.idModel} ref={modalGenManager} noButtons modelsList={props.configModel ? props.configModel : []} appProps={props} checkRights={props.checkRights} getRoutes={props.getRoutes} parentProps={{ type: "editor", modelSrc: { ...props.modelSrc, extID: loadExtID } }} configModel={gendata} traceModel={JSON.stringify(gendata)} loadedData={null}
                prevAction={<Button className="btn-round btn-icon m-0" color="secondary" onClick={props.reset}><i className="fa fa-arrow-left"></i></Button>} />


            <div ref={gridRef} className="grid-stack2" />
        </div>
    );


    /*return (
        <div>
                <div>
                    {widgetsList.map(widget => (
                        <button key={widget.id} onClick={() => addWidget(widget)}>
                            Add {widget.id}
                        </button>
                    ))}
                </div>
                <div ref={gridRef} className="grid-stack" />
            </div>
            );*/

});